import moment from "moment";

// Flattens a FastJsonapi serializable_hash ({ data: [...] }) into plain rows.
// Dates stay as "YYYY-MM-DD" strings and are compared as local calendar dates.
export const normalizeHolidays = (payload) => {
  const rows = (payload && payload.data) || [];
  const list = Array.isArray(rows) ? rows : [rows];

  return list.map((row) => {
    const attrs = row.attributes || {};
    return {
      id: row.id,
      name: attrs.name,
      from: attrs.holiday_date,
      to: attrs.end_date || attrs.holiday_date,
      end_date: attrs.end_date,
    };
  });
};

const dayKey = (date) => moment(date).format("YYYY-MM-DD");

export const formatDay = (day) => moment(day, "YYYY-MM-DD").format("DD/MM/YYYY");

export const findBlocked = (holidays, date) => {
  if (!date || !holidays || !holidays.length) return null;
  const key = dayKey(date);
  return holidays.find((h) => h.from <= key && key <= h.to) || null;
};

// First blocked range touching any day of start..end (inclusive).
export const findBlockedInRange = (holidays, start, end) => {
  if (!start || !holidays || !holidays.length) return null;
  const startKey = dayKey(start);
  const endKey = end ? dayKey(end) : startKey;
  const last = endKey < startKey ? startKey : endKey;
  return holidays.find((h) => h.from <= last && startKey <= h.to) || null;
};

export const blockedMessage = (holiday, date) =>
  `Bookings are not available on ${moment(date).format("DD/MM/YYYY")}: ${
    holiday.name
  }`;



// WEBPACK FOOTER //
// ./src/services/bankHolidays.js